var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-doc-player__toolbar" },
    [
      _vm._l(_vm.operations, function (item) {
        var _obj
        return _c(
          "div",
          {
            key: item.type,
            staticClass: "yxtbiz-doc-player__toolbar-item",
            class:
              ((_obj = { "is-page": item.type === "page" }),
              (_obj[item.className] = true),
              (_obj["is-disabled"] = item.disabled),
              _obj),
            on: {
              click: function ($event) {
                return _vm.handle(item)
              },
            },
          },
          [
            item.type === "page"
              ? [
                  _c(
                    "div",
                    { staticClass: "yxtbiz-doc-player__toolbar-page" },
                    [
                      _c("yxt-input", {
                        attrs: { size: "mini", disabled: !_vm.total },
                        on: {
                          blur: function ($event) {
                            _vm.current = _vm.page
                          },
                        },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.change(_vm.current)
                          },
                        },
                        model: {
                          value: _vm.current,
                          callback: function ($$v) {
                            _vm.current = $$v
                          },
                          expression: "current",
                        },
                      }),
                      _c("span", { staticClass: "mh4" }, [_vm._v("/")]),
                      _vm._v("\n        " + _vm._s(_vm.total) + "\n      "),
                    ],
                    1
                  ),
                ]
              : _c("yxtf-svg", {
                  attrs: {
                    "icon-class": item.icon,
                    width: "20px",
                    height: "20px",
                  },
                }),
          ],
          2
        )
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }